module.exports = __webpack_public_path__ + "img/price3.11550695.jpg";